import type { Dictionary } from '@/lib/i18n/dictionaries';
import { Reveal } from '@/components/site/reveal';

export function ManifestoSection({ dict }: { dict: Dictionary }) {
  return (
    <section className="relative isolate overflow-hidden border-y border-border bg-secondary/40 py-14 md:py-20">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent/60 to-transparent"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-accent/60 to-transparent"
      />
      <div className="container-tight">
        <Reveal>
          <blockquote className="mx-auto max-w-3xl text-center">
            <p className="font-serif text-2xl italic leading-snug text-primary md:text-3xl lg:text-4xl">
              <span aria-hidden="true" className="mr-1 align-top text-accent">&ldquo;</span>
              {dict.brand.manifesto}
              <span aria-hidden="true" className="ml-1 align-top text-accent">&rdquo;</span>
            </p>
          </blockquote>
          <p className="mx-auto mt-6 max-w-2xl text-center text-xs text-muted-foreground sm:text-sm md:text-base">
            {dict.brand.etymology}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
